import type { UserStatus } from '@/types/user';

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
} as const satisfies Record<string, UserStatus>;

export const STATUS_LABELS: Record<UserStatus, string> = {
  ACTIVE: '正常',
  DISABLED: '停用',
};

export const ADMIN_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'ADMIN', label: '系统管理员' },
  { value: 'BUSINESS', label: '普通用户' },
] as const;
